@if (slide; as $slide) {
  <div class="heading heading-bold-text">{{$slide.title}}</div>
  <div class="body flex-fill">
    @for ($part of $slide.parts; track $part) {
      <div
        [ngClass]="partClasses($part)"
        >
        @for ($answer of $part.answers; track $answer) {
          <div class="guess" [innerHTML]="$answer"></div>
        }
      </div>
    }
  </div>
}
